// Services
import callAPI from "../callApi";
import path from "../variables";

const packages = {
	getAll: (params: string) =>
		callAPI(
			"GET",
			`${path.base}/operation/packages${params ? params : ""}`,
			"",
			"getting all packages"
		),
	getDailyTotalForCurrentUser: (filter: any) =>
			callAPI(
				"GET",
				`${path.base}/report/packages/daily-totals-by-current-user${filter ? filter : ""}`,
				"",
				"getting daily package stats for current user"
			),
	availableToPickup: (params: string) =>
		callAPI(
			"GET",
			`${path.base}/operation/packages/pickup${params ? params : ""}`,
			"",
			"getting all packages to pickup"
		),
	pickup: (params: string) =>
		callAPI(
			"PUT",
			`${path.base}/operation/packages/pickup${params ? params : ""}`,
			"",
			"pickup a package"
		),
	confirmDelivery: (data: FormData, params?: string) =>
		callAPI(
			"UPLOAD",
			`${path.base}/operation/packages/delivery-proof${params ? params : ""}`,
			data,
			"confirm delivery with proof"
		),
	changeStatus: (data:any, params: string) =>
		callAPI(
			"PUT",
			`${path.base}/operation/packages/status${params ? params : ""}`,
			data,
			"changing status package"
		),
	// Scan unifié (traçabilité) : { payload, action, station, expedition?, latitude?, longitude?, note? }
	scan: (data: any, params?: string) =>
		callAPI(
			"POST",
			`${path.base}/operation/packages/scan${params ? params : ""}`,
			data,
			"scanning package"
		),
	// Suivi public d'un colis par référence (timeline événementielle).
	track: (reference: string) =>
		callAPI(
			"GET",
			`${path.base}/package/track?ref=${encodeURIComponent(reference)}`,
			"",
			"tracking package"
		),
	create: (data: any, params: string) =>
		callAPI(
			"POST",
			`${path.base}/operation/packages${params ? params : ""}`,
			data,
			"create new package"
		),
};

export default packages;
